import { ChangeDetectionStrategy, Component, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoreUiPartialState, getArbCentralNavSecurity } from '@pos-app/core-ui';

@Component({
    selector: 'app-action-cell',
    template: `
    <mat-icon (click)="invokeEditLineDetails($event)"> edit </mat-icon>
    <mat-icon (click)="invokeDeleteLineDetails($event)"> delete </mat-icon>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
      .btn {
        line-height: 0.5;
      }

      .dispatched {
        color: green;
      }

      .stack-icon {
        position: absolute;
      }

      .stack-top {
        z-index: 9;
      }
    `,
    ],
    standalone: false
})
export class ManageCentralAllHelpComponentRender {
  params: any;
  lineAttachments: any[];
  arbCentralSecurityFunctions;

  constructor(private renderer: Renderer2, private coreUiStore: Store<CoreUiPartialState>) {}

  // Initialize component with parameters
  agInit(params: any): void {
    this.params = params;
    this.lineAttachments = params.data.attachmentIDArray;
    // this.coreUiStore
    //   .select(getArbCentralNavSecurity)
    //   .pipe()
    //   .subscribe((data) => {
    //     this.arbCentralSecurityFunctions = data;
    //   });
  }

  // Invoke method to handle line details
  public invokeEditLineDetails(params) {
    this.params.context.componentParent.editHelpComponenetDetail(this.params.data);
  }
  public invokeDeleteLineDetails(params) {
    this.params.context.componentParent.deleteHelpComponenetDetail(this.params.data);
  }
}

